module.exports = __webpack_public_path__ + "img/ga.2a9abfb7.svg";